import HighlightStore from '../stores/highlight-store';

var Labs = {

  setupDefaultLabs: function(){
    const gadgets = require('../components/gadgets/gadgets');
    if (Fraction.User){
      gadgets.forEach((gadget) => {
        const metadata = gadget.metadata();
        if (metadata.lab && !Fraction.User.labs[metadata.id]){
          Fraction.User.labs[metadata.id] = {name: metadata.id, rating: 0, enabled: metadata.defaultEnabled && metadata.defaultEnabled()};
        }
      });
    }
  },

  enableLab(labId) {
    return new Promise((resolve, reject) => {
    if (Fraction.User){
        Jigsaw.Labs.enable(labId, function(response){
          if (response.isSuccess()){
            Fraction.User.labs[labId] = Fraction.User.labs[labId] || {name: labId, rating: 0};
            Fraction.User.labs[labId].enabled = true;
            resolve();
          } else {
            reject(response);
          }
        });
      } else {
        reject("No user");
      }
    });
  },

  disableLab(labId) {
    return new Promise((resolve, reject) => {
      if (Fraction.User){
        Jigsaw.Labs.disable(labId, function(response){
          if (response.isSuccess()){
            Fraction.User.labs[labId] = Fraction.User.labs[labId] || {name: labId, rating: 0};
            Fraction.User.labs[labId].enabled = false;
            resolve();
          } else {
            reject(response);
          }
        });
      } else {
        reject("No user")
      }
    });
  },

  toggleLab: function(labId, callback){
    if (Fraction.User){
      if (Fraction.User.labs[labId] && Fraction.User.labs[labId].enabled){
        Fraction.Helpers.disableLab(labId, callback);
      } else {
        Fraction.Helpers.enableLab(labId, callback);
      }
    }
  },

  isLabEnabled: function(labId, callback){
    return Fraction.User && Fraction.User.labs[labId] && Fraction.User.labs[labId].enabled;
  },

  submitFeedback: function(value, lab_name, isbn){
    const highlightObject = HighlightStore.getAll(isbn);
    $.ajax({
     url: "https://docs.google.com/forms/d/1AoRKj5taBqfNDhwTepwugCNzuJxTgC1cj0pfoZDqvuM/formResponse",
     type: "POST",
     data: {
      "entry.297801385": Fraction.User.email.hashMe(), // user email
      "entry.73219375": value, // labs feedback
      "entry.1521784677": lab_name, // labs feature
      "entry.1043057405": highlightObject.highlights ? highlightObject.highlights.length : "", // my highlights
      "entry.1837228594": highlightObject.subscribedHighlights ? highlightObject.subscribedHighlights.length : "", // other highlights
      "entry.1552791793": brands.brand_name, // brand
      "entry.754907892": isbn || "", // vbid
      "entry.2074013376": navigator.userAgent, // user agent
      "entry.754282536": $(window).width() // screen width
     }
    });
  }

};

module.exports = Labs;
